module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_DPO.52d62874.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_DPO.png
// module id = 50
// module chunks = 0